// A prompt authored as a TypeScript template literal is hard-wrapped at ~100 columns for source
// readability, but that line break is not a real paragraph break -- rendered verbatim in a
// `<textarea>` (or sent as-is to the model) it shows up as a newline mid-sentence. A genuine
// paragraph break (two or more consecutive newlines, e.g. between the numbered rules of a system
// instruction) must be preserved.
export function joinWrappedParagraphs(text: string): string {
  return text
    .trim()
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.replace(/\s*\n\s*/g, ' ').trim())
    .join('\n\n');
}
